import React from "react";
import CataloguePage from "../catalogue-page/CataloguePage";

const FashionCatalogue: React.FC = () => {
  return (
    <CataloguePage
      heading="Fashion"
      description="Discover stylish and comfortable fashion items, perfect for any occasion. Upgrade your wardrobe with our latest collection."
      categoryFilter="fashion"
    />
  );
};

export default FashionCatalogue;
